var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.show,"content-class":"fileuploader-dialog"}},_vm._l((_vm.statuses),function(status){return _c('UploadStatus',{key:status.filename,attrs:{"progress":status.progress,"filename":status.filename}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }